import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './Splash.module.css';

const Splash: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);

  useEffect(() => {
    // Ensure splash shows for at least 2 seconds
    const timer = setTimeout(() => {
      setMinTimeElapsed(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Redirect only after auth check is complete and min time elapsed
    if (!isLoading && minTimeElapsed) {
      if (isAuthenticated) {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, minTimeElapsed, navigate]);

  return (
    <div className={styles.splashContainer}>
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <div className={styles.logo}>
            <span className={styles.logoIcon}>🚀</span>
          </div>
        </div>

        <h1 className={styles.brandName}>
          <span className={styles.brand}>Startup</span>
          <span className={styles.brandHighlight}>Rahi</span>
        </h1>

        <p className={styles.tagline}>Admin Panel</p>

        <div className={styles.loaderWrapper}>
          <div className={styles.loader}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
          </div>
        </div>

        <p className={styles.version}>v1.0.0</p>
      </div>

      <div className={styles.bgGradient1}></div>
      <div className={styles.bgGradient2}></div>
    </div>
  );
};

export default Splash;